<template>
  <div class="container">
    <div class="top">
      <img src="../../assets/images/mhbanner.png" alt="专项工作图片" />
    </div>
    <div class="middle disCen">
      <div class="box">
        <div class="serach disCen">
          <div class="linkage-right">
            <input type="text" placeholder="请输入" v-model="searchValues" class="no-outline-input" />
            <div class="button" @click="istrue">
              <img src="../../assets/images/search.png" alt="" />
            </div>
          </div>
        </div>
        <div class="content">
          <div class="left">
            <div class="tops">
              <img src="../../assets/images/dxal.png" alt="" />
            </div>
            <div class="list">
              <div class="political-education">
                <div class="sec-right-title">
                  <div class="tag">
                    <img src="../../assets/images/mhSec.png" alt="" />
                    <span>全国典型案例</span>
                  </div>
                  <div class="more-box">
                    <div class="more" @click="gengduo(6)">
                      更多 >>
                    </div>
                  </div>
                </div>
                <ul class=" custom-list">
                  <li v-for="(item, index) in quanguo" :key="index" @click="">
                    <div class="li-content">
                      <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                        <div class="custom-link hover-underline" style="display: flex">
                          <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                            :open-delay="500">
                            <div class="custom-link-text" @click="goInfo(item)">{{ item.messageName }}</div>
                          </el-tooltip>
                        </div>
                        <div v-if="newsDate == item.releaseTime">
                            <img
                              style="width: 32px; height: 14px"
                              src="../../assets/images/news.gif"
                              alt=""
                            />
                          </div>
                        <div v-else>[{{ item.releaseTime }}]</div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="political-education">
                <div class="sec-right-title">
                  <div class="tag">
                    <img src="../../assets/images/mhSec.png" alt="" />
                    <span>本省典型案例</span>
                  </div>
                  <div class="more-box">
                    <div class="more" @click="gengduo(7)">
                      更多 >>
                    </div>
                  </div>
                </div>
                <ul class=" custom-list">
                  <li v-for="(item, index) in bensheng" :key="index" @click="">
                    <div class="li-content">
                      <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                        <div class="custom-link hover-underline" style="display: flex">
                          <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                            :open-delay="500">
                            <div class="custom-link-text" @click="goInfo(item)">{{ item.messageName }}</div>
                          </el-tooltip>
    
                        </div>
                        <div v-if="newsDate == item.releaseTime">
                            <img
                              style="width: 32px; height: 14px"
                              src="../../assets/images/news.gif"
                              alt=""
                            />
                          </div>
                        <div v-else>[{{ item.releaseTime }}]</div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="political-education">
                <div class="sec-right-title">
                  <div class="tag">
                    <img src="../../assets/images/mhSec.png" alt="" />
                    <span>市本级典型案例</span>
                  </div>
                  <div class="more-box">
                    <div class="more" @click="gengduo(8)">
                      更多 >>
                    </div>
                  </div>
                </div>
                <ul class=" custom-list">
                  <li v-for="(item, index) in benshi" :key="index" @click="goInfo(item)">
                    <div class="li-content">
                      <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                        <div class="custom-link hover-underline" style="display: flex">
                          <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                            :open-delay="500">
                            <div @click="goInfo(item)">{{ item.messageName }}</div>
                          </el-tooltip>
                          
                        </div>
                        <div v-if="newsDate == item.releaseTime">
                            <img
                              style="width: 32px; height: 14px"
                              src="../../assets/images/news.gif"
                              alt=""
                            />
                          </div>
                        <div v-else>[{{ item.releaseTime }}]</div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="tops">
              <img src="../../assets/images/mhjy.png" alt="" />
            </div>
            <div class="list">
              <div class="political-education">
                <div class="sec-right-title">
                  <div class="tag">
                    <img src="../../assets/images/mhSec.png" alt="" />
                    <span>灭火救援预案</span>
                  </div>
                  <div class="more-box">
                    <div class="more"  @click="gengduo(0)">
                      更多 >>
                    </div>
                  </div>
                </div>
                <div class=" content-left-thr-content">
                  <div class="content-left-thr-left texts">
                    <div class="row" style="margin-top: 2px; margin-left: 12px">
                      <div class="row-left hover-underlines" @click="gengduo(0)">
                        <span style="margin: 0; padding: 0">贵</span>
                        <span style="margin: 0; padding: 0">池 :</span>
                      </div>
                      <div class="row-right">
                        <div class="li-content my-li" v-for="(item, index) in guichi" :key="index">
                          <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                            <div class="custom-link hover-underline" style="display: flex">
                              <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                                :open-delay="500">
                                <div class="custom-link-text2 hover-underline" @click="goInfo(item)">{{ item.messageName }}</div>
                              </el-tooltip>
                              <div v-if="newsDate == item.releaseTime">
                                <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-top: 2px; margin-left: 12px">
                      <div class="row-left hover-underlines" @click="gengduo(2)">
                        <span>石</span>
                        <span>台 :</span>
                      </div>
                      <div class="row-right">
                        <div class="li-content my-li" v-for="(item, index) in shitai" :key="index"
                          >
                          <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                            <div class="custom-link hover-underline" style="display: flex">
                              <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                                :open-delay="500">
                                <div class="custom-link-text2" @click="goInfo(item)">{{ item.messageName }}</div>
                              </el-tooltip>
                              <div v-if="newsDate == item.releaseTime">
                                <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-top: 2px; margin-left: 12px">
                      <div class="row-left hover-underlines" @click="gengduo(4)">
                        <span>九</span>
                        <span>华</span>
                        <span>山 :</span>
                      </div>

                      <div class="row-right">
                        <div class="li-content my-li" v-for="(item, index) in jiuhuashan" :key="index"
                          >
                          <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                            <div class="custom-link hover-underline" style="display: flex">
                              <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                                :open-delay="500">
                                <div class="custom-link-text2" @click="goInfo(item)">{{ item.messageName }}</div>
                              </el-tooltip>
                              <div v-if="newsDate == item.releaseTime">
                                <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content-left-thr-left texts content-left-right">
                    <div class="row" style="margin-top: 2px">
                      <div class="row-left hover-underlines" @click="gengduo(1)">
                        <span>东</span>
                        <span>至 :</span>
                      </div>

                      <div class="row-right">
                        <div class="li-content my-li" v-for="(item, index) in dongzhi" :key="index"
                          >
                          <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                            <div class="custom-link hover-underline" style="display: flex">
                              <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                                :open-delay="500">
                                <div class="custom-link-text2" @click="goInfo(item)">{{ item.messageName }}</div>
                              </el-tooltip>
                              <div v-if="newsDate == item.releaseTime">
                                <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-top: 2px">
                      <div class="row-left hover-underlines" @click="gengduo(3)">
                        <span>青</span>
                        <span>阳 :</span>
                      </div>
                      <div class="row-right">
                        <div class="li-content my-li" v-for="(item, index) in qingyang" :key="index"
                          >
                          <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                            <div class="custom-link hover-underline" style="display: flex">
                              <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                                :open-delay="500">
                                <div class="custom-link-text2" @click="goInfo(item)">{{ item.messageName }}</div>
                              </el-tooltip>
                              <div v-if="newsDate == item.releaseTime">
                                <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-top: 2px">
                      <div class="row-left hover-underlines" @click="gengduo(5)">
                        <span>特</span>
                        <span>勤 :</span>
                      </div>
                      <div class="row-right">
                        <div class="li-content my-li" v-for="(item, index) in teqin" :key="index">
                          <div style="
                          display: flex;
                          justify-content: space-between;
                          width: 100%;
                        ">
                            <div class="custom-link hover-underline" style="display: flex">
                              <el-tooltip class="item" effect="dark" :content="item.messageName" placement="top"
                                :open-delay="500">
                                <div class="custom-link-text2" @click="goInfo(item)">{{ item.messageName }}</div>
                              </el-tooltip>
                              <div v-if="newsDate == item.releaseTime">
                                <img style="width: 32px; height: 14px" src="../../assets/images/news.gif" alt="" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-info">
      <div class="bottom-box">
        <div>
          <span class="hover-underline" @click="tps(0)">首页</span>
          <span> 丨 </span>
          <span class="hover-underline" @click="tps(1)">地理位置</span>
          <span> 丨 </span>
          <span class="hover-underline" @click="tps(2)">联系我们</span>
          <span> 丨 </span>
          <span class="hover-underline" @click="tps(3)">技术支持</span>
        </div>
        <div>主办单位：池州市消防救援支队</div>
      </div>
    </div>
  </div>
</template>
<script>
import { listReleaseCopy } from "@/api/index";
export default {
  data() {
    return {
      searchValue: "",
      guichi: [],
      dongzhi: [],
      shitai: [],
      qingyang: [],
      jiuhuashan: [],
      teqin: [],
      quanguo: [],
      bensheng: [],
      benshi: [],
      newsDate: '',
      searchValues:'',
    };
  },
  created() {
    this.getCurrentDate()
    this.listReleaseCopyAll()
  },
  methods: {
    istrue() {
      const searchValues = this.searchValues;
      const url = `/?searchValues=${encodeURIComponent(searchValues)}`;
      window.open(url, "_blank");
    },
    gengduo(type) {
      let eletypes = type;
      const url = `/?eletypes=${encodeURIComponent(eletypes)}`;
      // this.showHome = !this.showHome;
      window.open(url, "_blank");
    },
    goInfo(item) {
      let url = '';
      if (item.fileUrl) {
        url = item.fileUrl;
        window.open(url, "_blank");
      }
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，所以加1
      const day = String(date.getDate()).padStart(2, "0");

      const days = `${year}-${month}-${day}`;
      this.newsDate = `${month}-${day}`;
    },
    listReleaseCopyAll() {
      listReleaseCopy({ pageSize: 10, pageNum: 1,status:4, messageType: 0 }).then(res => {
        if (res.data.code == 200) {
          this.guichi = res.data.data.list
          this.guichi.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
          })
        }
      })
      listReleaseCopy({ pageSize: 10, pageNum: 1,status:4, messageType: 1 }).then(res => {
        if (res.data.code == 200) {
          this.dongzhi = res.data.data.list
          this.dongzhi.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
          })
        }
      })
      listReleaseCopy({ pageSize: 10, pageNum: 1,status:4, messageType: 2 }).then(res => {
        if (res.data.code == 200) {
          this.shitai = res.data.data.list
          this.shitai.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
          })
        }
      })
      listReleaseCopy({ pageSize: 10, pageNum: 1,status:4, messageType: 3 }).then(res => {
        if (res.data.code == 200) {
          this.qingyang = res.data.data.list
          this.qingyang.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
          })
        }
      })
      listReleaseCopy({ pageSize: 10, pageNum: 1,status:4, messageType: 4 }).then(res => {
        if (res.data.code == 200) {
          this.jiuhuashan = res.data.data.list
          this.jiuhuashan.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
          })
        }
      })
      listReleaseCopy({ pageSize: 10, pageNum: 1,status:4, messageType: 5 }).then(res => {
        if (res.data.code == 200) {
          this.teqin = res.data.data.list
          this.teqin.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
          })
        }
      })
      listReleaseCopy({ pageSize: 10, pageNum: 1,status:4, messageType: 6 }).then(res => {
        if (res.data.code == 200) {
          this.quanguo = res.data.data.list
          this.quanguo.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
          })
        }
      })
      listReleaseCopy({ pageSize: 10, pageNum: 1,status:4, messageType: 7 }).then(res => {
        if (res.data.code == 200) {
          this.bensheng = res.data.data.list
          this.bensheng.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
          })
        }
      })
      listReleaseCopy({ pageSize: 10, pageNum: 1,status:4, messageType: 8 }).then(res => {
        if (res.data.code == 200) {
          this.benshi = res.data.data.list
          this.benshi.map((item) => {
            if (item.releaseTime) {
              item.releaseTime = item.releaseTime.slice(5, 10);
            }
          })
        }
      })
    },
    tps(type) {
      let url
      if (type == 1) {
        url = `/?organization=地理位置`;
      } else if (type == 2) {
        url = `/?call=1`;
      } else if (type == 3) {
        url = `http://www.ahqmkeji.com/aboutus`;
      } else {
        url = `/`;
      }
      window.open(url, "_blank");
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  width: 100%;
  height: 100vh;
  background-color: #fff;

  .top {
    width: 100%;
    height: 241px;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;

    img {
      width: 100%;
      height: 400px;
      margin: 0;
    }
  }

  .middle {
    width: 100%;

    .box {
      width: 1204px;
      padding: 0 14px;
    }
  }
}

.disCen {
  display: flex;
  justify-content: center;
}

.serach {
  margin-bottom: 40px;
}

.linkage-right {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 660px;

  input {
    width: 616px;
    height: 40px;
    border-radius: 4px 0px 0px 4px;
    border: 1px solid #2b56ac;
  }

  .no-outline-input {
    outline: none;
  }

  .no-outline-input:focus {
    border-color: #2b56ac;
  }

  .button {
    width: 44px;
    height: 44px;
    background: #2b56ac;
    border-radius: 0px 4px 4px 0px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 11px;
      height: 12px;
    }
  }
}

.content {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .left {
    width: 592px;
  }

  .right {
    width: 592px;
  }

  .tops {
    width: 592px;
    margin-bottom: 24px;

    img {
      width: 592px;
      height: 99px;
    }
  }
}

.political-education {
  width: 592px;
  height: 292px;

  .sec-right-title {
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .more-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      right: 12px;
      bottom: 4px;
      color: #2e5bb6;
      font-size: 12px;
      cursor: pointer;
    }

    .tag {
      width: 100%;
      position: relative;

      img {
        width: 100%;
        height: 30px;
        margin-top: 3px;
      }

      span {
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        // width: 64px;
        height: 24px;
        top: 6px;
        left: 16px;
        position: absolute;
      }
    }
  }
}

.content-left-thr-content {
  display: flex;
  justify-content: space-between;
  height: 398px;
}

.content-left-thr-left {
  width: 50%;
  height: 200px;

  .row {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  .row-left {
    display: flex;
    justify-content: space-between;
    padding: 0;
    width: 52px;
    margin-top: 8px;
    font-size: 14px;
    font-weight: bold;
    color: #e71111;
  }

  .row-right {
    width: 80%;
    height: 277px;
    margin-left: 8px;
  }
}

.hover-underline {
  cursor: pointer;
  /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline;
  /* 悬停时添加下划线 */
}

.hover-underlines {
  cursor: pointer;
  /* 鼠标悬停时显示手形光标 */
}

.hover-underlines:hover {
  // text-decoration: underline; /* 悬停时添加下划线 */
  border-bottom: 1px solid #e71137;
}
.custom-link {
  // margin-right: 8px;
  color: inherit;
  text-decoration: none;
  pointer-events: all;
}
.custom-link-text2 {
  width: 190px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-link-text {
  width: 470px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.texts {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.content-left-right {
  margin-left: 10px;
}

.my-li {
  margin: 8px 0;
}

.li-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  pointer-events: none;

  span {
    display: inline-block;
    width: 40px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    background: #ffdfdf;
    border-radius: 4px;
    font-size: 10px;
    color: #cc0000;
    // margin-left: 10px;
  }
}

.custom-list {
  list-style-type: none;
  padding: 0 12px;
  margin: 0;
}

.custom-list li {
  position: relative;
  padding-left: 18px;
  margin: 7px 0;
  pointer-events: none;
}

.custom-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  background-color: #c1c5cd;
  border-radius: 50%;
}

.bottom-info {
  width: 1232px;
  height: 100px;
  background: linear-gradient(180deg, #0E67AB 0%, #073456 100%);
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
</style>
